import React, { useState, useEffect } from 'react'
import { Panel, Message, Row, Col, Form, Input, Button, ControlLabel, SelectPicker } from 'rsuite'
import { useForm, Controller } from 'react-hook-form'
import ButtonPanelWidget from '../ButtonPanelWidget'
import { startLoading, doneLoading } from '../../utils/loading'
import ErrorMessage from '../../components/message/errorMessage/ErrorMessage'
import { isValidators, requiredFiled } from '../../utils/ValidatorUtils'
import moment from 'moment'
import { DATE_PICKER_FORMAT, LOCAL_DAY_TH } from '../../constants/date'
import classNames from 'classnames'
import AppContext from '../../context/AppContext'
// import './styles.less'
import SearchButton from '../../components/buttons/searchButton/SearchButton'
import CancelButton from '../../components/buttons/cancelButton/CancelButton'

export default function SearchLawForm({
  onSubmitData = () => {},
  onCancelData = () => {},
  ...props
}) {
  const { theme } = React.useContext(AppContext)
  const {
    // onSubmitData,
    // onCancelData,
    register,
    errors,
    error,
    Controller,
    control,
    setValue,
    getValues,
    clearErrors,
    PanelExpanded,
  } = props

  const [formSchema, setFormSchema] = useState(props.schema)
  const [lawTypeVal, setLawTypeVal] = useState()
  const [litigationNameVal, setLitigationNameVal] = useState()
  const [projectCodeVal, setProjectCodeVal] = useState()
  const [docNumberOfPurchaseVal, setDocNumberOfPurchaseVal] = useState()
  const [contractNumberRefVal, setContractNumberRefVal] = useState()
  const [lawStatusVal, setLawStatusVal] = useState()
  const [lawSubStatusVal, setLawSubStatusVal] = useState()
  const [projectNameVal, setProjectNameVal] = useState()
  const [departmentVal, setDepartmentVal] = useState()

  const [panelExpan, setPanelExpan] = useState(false)

  useEffect(() => {
    setPanelExpan(!PanelExpanded)
  }, [PanelExpanded])

  const twoCol = {
    first: {
      _lg: 12,
      _md: 12,
      _sm: 24,
      _xs: 24,
    },
    second: {
      _lg: 12,
      _md: 12,
      _sm: 24,
      _xs: 24,
    },
  }

  const handlerOnSearch = () => {
    const data = {
      lawType: lawTypeVal || null,
      litigationName: litigationNameVal || null,
      projectCode: projectCodeVal || null,
      docNumberOfPurchase: docNumberOfPurchaseVal || null,
      contractNumberRef: contractNumberRefVal || null,
      lawStatus: lawStatusVal || null,
      lawSubStatus: lawSubStatusVal || null,
      projectName: projectNameVal || null,
      department: departmentVal || null,
      pageNumber: 1,
      pageSize: 5,
    }

    // console.log('handlerOnSearch : ', data)
    onSubmitData(data)
  }

  const handlerOnCancel = () => {
    setLawTypeVal('')
    setLitigationNameVal('')
    setProjectCodeVal('')
    setDocNumberOfPurchaseVal('')
    setContractNumberRefVal('')
    setLawStatusVal('')
    setLawSubStatusVal('')
    setProjectNameVal('')
    setDepartmentVal('')

    const data = {
      lawType: null,
      litigationName: null,
      projectCode: null,
      docNumberOfPurchase: null,
      contractNumberRef: null,
      lawStatus: null,
      lawSubStatus: null,
      projectName: null,
      department: null,
      pageNumber: 1,
      pageSize: 5,
    }

    // console.log('handlerOnCancel : ', data)

    onCancelData(data)
  }

  return (
    <>
      <Panel
        collapsible
        defaultExpanded
        bordered
        header={formSchema.header || 'ค้นหา'}
        expanded={panelExpan}
        onSelect={() => {
          setPanelExpan(!panelExpan)
        }}
      >
        <Form>
          <Row>
            {formSchema?.lawType && (
              <>
                <Col
                  lg={twoCol.second._lg}
                  md={twoCol.second._md}
                  sm={twoCol.second._sm}
                  xs={twoCol.second._xs}
                  style={{
                    marginTop: '5px',
                    padding: '8px',
                  }}
                >
                  <ControlLabel>
                    {requiredFiled(formSchema.lawType.validators, formSchema.lawType.label)}
                  </ControlLabel>

                  <Controller
                    name={formSchema.lawType.name}
                    control={control}
                    defaultValue={formSchema.lawType.value}
                    rules={isValidators(formSchema.lawType.validators)}
                    render={(props) => {
                      return (
                        <SelectPicker
                          data={formSchema.lawType.options}
                          searchable={true}
                          disabled={formSchema.lawType.disabled}
                          value={props.value}
                          block
                          placeholder={
                            formSchema.lawType.hint || `เลือก${formSchema.lawType.label}`
                          }
                          onChange={(value) => {
                            props.onChange(value)
                            setLawTypeVal(value)
                          }}
                        />
                      )
                    }}
                  />
                </Col>
              </>
            )}

            {formSchema?.department && (
              <>
                <Col
                  lg={twoCol.second._lg}
                  md={twoCol.second._md}
                  sm={twoCol.second._sm}
                  xs={twoCol.second._xs}
                  style={{
                    marginTop: '5px',
                    padding: '8px',
                  }}
                >
                  <ControlLabel>
                    {requiredFiled(formSchema.department.validators, formSchema.department.label)}
                  </ControlLabel>

                  <Controller
                    name={formSchema.department.name}
                    control={control}
                    defaultValue={formSchema.department.value}
                    rules={isValidators(formSchema.department.validators)}
                    render={(props) => {
                      return (
                        <SelectPicker
                          data={formSchema.department.options}
                          searchable={true}
                          disabled={formSchema.department.disabled}
                          value={props.value}
                          block
                          placeholder={
                            formSchema.department.hint || `เลือก${formSchema.department.label}`
                          }
                          onChange={(value) => {
                            props.onChange(value)
                            setDepartmentVal(value)
                          }}
                        />
                      )
                    }}
                  />
                </Col>
              </>
            )}
            {formSchema?.projectCode && (
              <Col
                lg={twoCol.second._lg}
                md={twoCol.second._md}
                sm={twoCol.second._sm}
                xs={twoCol.second._xs}
                style={{
                  marginTop: '5px',
                  padding: '8px',
                }}
              >
                <ControlLabel>
                  {requiredFiled(formSchema.projectCode.validators, formSchema.projectCode.label)}
                </ControlLabel>
                <Input
                  placeholder={formSchema.projectCode.hint}
                  defaultValue={formSchema.projectCode.value}
                  value={projectCodeVal}
                  name={formSchema.projectCode.name}
                  onChange={(value) => setProjectCodeVal(value)}
                  // inputRef={register(isValidators(formSchema.projectCode.validators))}
                />
              </Col>
            )}

            {formSchema?.projectName && (
              <Col
                lg={twoCol.second._lg}
                md={twoCol.second._md}
                sm={twoCol.second._sm}
                xs={twoCol.second._xs}
                style={{
                  marginTop: '5px',
                  padding: '8px',
                }}
              >
                <ControlLabel>
                  {requiredFiled(formSchema.projectName.validators, formSchema.projectName.label)}
                </ControlLabel>
                <Input
                  placeholder={formSchema.projectName.hint}
                  defaultValue={formSchema.projectName.value}
                  value={projectNameVal}
                  name={formSchema.projectName.name}
                  onChange={(value) => setProjectNameVal(value)}
                  // inputRef={register(isValidators(formSchema.projectCode.validators))}
                />
              </Col>
            )}

            {formSchema?.litigationName && (
              <Col
                lg={twoCol.first._lg}
                md={twoCol.first._md}
                sm={twoCol.first._sm}
                xs={twoCol.first._xs}
                style={{
                  marginTop: '5px',
                  padding: '8px',
                }}
              >
                <ControlLabel>
                  {requiredFiled(
                    formSchema.litigationName.validators,
                    formSchema.litigationName.label
                  )}
                </ControlLabel>
                <Input
                  placeholder={formSchema.litigationName.hint}
                  defaultValue={formSchema.litigationName.value}
                  value={litigationNameVal}
                  name={formSchema.litigationName.name}
                  onChange={(value) => setLitigationNameVal(value)}
                  // inputRef={register(isValidators(formSchema.contractNumberRef.validators))}
                />
              </Col>
            )}

            {formSchema?.docNumberOfPurchase && (
              <Col
                lg={twoCol.second._lg}
                md={twoCol.second._md}
                sm={twoCol.second._sm}
                xs={twoCol.second._xs}
                style={{
                  marginTop: '5px',
                  padding: '8px',
                }}
              >
                <ControlLabel>
                  {requiredFiled(
                    formSchema.docNumberOfPurchase.validators,
                    formSchema.docNumberOfPurchase.label
                  )}
                </ControlLabel>
                <Input
                  placeholder={formSchema.docNumberOfPurchase.hint}
                  defaultValue={formSchema.docNumberOfPurchase.value}
                  value={docNumberOfPurchaseVal}
                  name={formSchema.projectName.name}
                  onChange={(value) => setDocNumberOfPurchaseVal(value)}
                  // inputRef={register(isValidators(formSchema.docNumberOfPurchase.validators))}
                />
              </Col>
            )}

            {formSchema?.contractNumberRef && (
              <Col
                lg={twoCol.first._lg}
                md={twoCol.first._md}
                sm={twoCol.first._sm}
                xs={twoCol.first._xs}
                style={{
                  marginTop: '5px',
                  padding: '8px',
                }}
              >
                <ControlLabel>
                  {requiredFiled(
                    formSchema.contractNumberRef.validators,
                    formSchema.contractNumberRef.label
                  )}
                </ControlLabel>
                <Input
                  placeholder={formSchema.contractNumberRef.hint}
                  defaultValue={formSchema.contractNumberRef.value}
                  value={contractNumberRefVal}
                  name={formSchema.contractNumberRef.name}
                  onChange={(value) => setContractNumberRefVal(value)}
                  // inputRef={register(isValidators(formSchema.contractNumberRef.validators))}
                />
              </Col>
            )}
            {formSchema?.lawStatus && (
              <>
                <Col
                  lg={twoCol.second._lg}
                  md={twoCol.second._md}
                  sm={twoCol.second._sm}
                  xs={twoCol.second._xs}
                  style={{
                    marginTop: '5px',
                    padding: '8px',
                  }}
                >
                  <ControlLabel>
                    {requiredFiled(formSchema.lawStatus.validators, formSchema.lawStatus.label)}
                  </ControlLabel>

                  <Controller
                    name={formSchema.lawStatus.name}
                    control={control}
                    defaultValue={formSchema.lawTylawStatuspe.value}
                    rules={isValidators(formSchema.lawStatus.validators)}
                    render={(props) => {
                      return (
                        <SelectPicker
                          data={formSchema.lawStatus.options}
                          searchable={true}
                          disabled={formSchema.lawStatus.disabled}
                          value={props.value}
                          block
                          placeholder={
                            formSchema.lawStatus.hint || `เลือก${formSchema.lawStatus.label}`
                          }
                          onChange={(value) => {
                            props.onChange(value)
                            setLawStatusVal(value)
                          }}
                        />
                      )
                    }}
                  />
                </Col>
              </>
            )}
            {formSchema?.lawSubStatus && (
              <>
                <Col
                  lg={twoCol.second._lg}
                  md={twoCol.second._md}
                  sm={twoCol.second._sm}
                  xs={twoCol.second._xs}
                  style={{
                    marginTop: '5px',
                    padding: '8px',
                  }}
                >
                  <ControlLabel>
                    {requiredFiled(
                      formSchema.lawSubStatus.validators,
                      formSchema.lawSubStatus.label
                    )}
                  </ControlLabel>

                  <Controller
                    name={formSchema.lawSubStatus.name}
                    control={control}
                    defaultValue={formSchema.lawSubStatus.value}
                    rules={isValidators(formSchema.lawSubStatus.validators)}
                    render={(props) => {
                      return (
                        <SelectPicker
                          data={formSchema.lawSubStatus.options}
                          searchable={true}
                          disabled={formSchema.lawSubStatus.disabled}
                          value={props.value}
                          block
                          placeholder={
                            formSchema.lawSubStatus.hint || `เลือก${formSchema.lawSubStatus.label}`
                          }
                          onChange={(value) => {
                            props.onChange(value)
                            setLawSubStatusVal(value)
                          }}
                        />
                      )
                    }}
                  />
                </Col>
              </>
            )}
          </Row>
        </Form>

        <hr />

        {formSchema.buttonText && (
          <>
            <SearchButton onClick={handlerOnSearch}>
              {formSchema.buttonText.searchButtonName || ''}
            </SearchButton>
            <CancelButton onClick={handlerOnCancel}>
              {formSchema.buttonText.cancelButtonName || ''}
            </CancelButton>
          </>
        )}
      </Panel>
    </>
  )
}
